const DummyVendor = [
    {
        name: "Bank Sampah Bandung",
        phone_office: "081285059999",
        description: "Sarana Setor Bank Sampah Kota Bandung",
        address: "Indonesia",
        langitude: "0",
        longitude: "0",
        distance: "13.0 km",
        photo_1: "phot.jpg"
    },
    {
        name: "Bank Sampah Surabaya",
        phone_office: "081285059998",
        description: "Sarana Setor Bank Sampah Kota Surabaya",
        address: "Indonesia",
        langitude: "0",
        longitude: "0",
        distance: "823.0 km",
        photo_1: "phot.jpg"
    },
    {
        name: "Bank Sampah Semarang",
        phone_office: "081285059997",
        description: "Sarana Setor Bank Sampah Kota Semarang",
        address: "Indonesia",
        langitude: "0",
        longitude: "0",
        distance: "414.0 km",
        photo_1: "phot.jpg"
    },
    {
        name: "Bank Sampah Palembang",
        phone_office: "081285059999",
        description: "Sarana Setor Bank Sampah Kota Palembang",
        address: "Indonesia",
        langitude: "0",
        longitude: "0",
        distance: "412.0 km",
        photo_1: "phot.jpg"
    },

]

export default  DummyVendor